/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import TableHead from '@material-ui/core/TableHead';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import List from '@material-ui/core/List';
import AddIcon from '@material-ui/icons/Add';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PrintTwoToneIcon from '@material-ui/icons/PrintTwoTone';
import * as actions from '../../actions/index';
import {
  initDataConfig,
  selectPrinter,
  handleClose,
  handleChangePrinter,
  handleListItemClick
} from './PrinterConfig.services';
import { styles } from './PrinterConfig.styles';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import Paper from '../Paper';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Button from '../Button';
import BackButton from '../BackButton';
import { settings } from '../../constants';

const ListItem = withStyles({
  root: {
    paddingLeft: '0px',
    paddingBottom: '5px',
    paddingTop: '0px',
    paddingRight: '0px'
  },
  button: {
    width: 'auto',
    borderRadius: '6px',
    paddingTop: '8px',
    paddingBottom: '8px'
  }
})(MuiListItem);
const INITIAL_STATE = {
  currentPrinters: [],
  addPrintModal: false,
  printers: null,
  selectedPrinter: null,
  isLoading: false,
  isSearchingPrinters: false
};

class PrinterConfig extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    initDataConfig(this.props, this);
  }

  componentWillReceiveProps(nextProps) {
    const { configurations } = nextProps;
    const { configurations: oldConfigs } = this.props;
    const { printers } = configurations;
    const { printers: oldPrinters = {} } = oldConfigs;
    if (!_.isEqual(printers, oldPrinters)) initDataConfig(nextProps, this);
  }

  renderPrinters = () => {
    const { classes } = this.props;
    const { currentPrinters } = this.state;
    return (
      currentPrinters &&
      currentPrinters.map((e, i) => (
        <TableRow key={i.toString()}>
          <TableCell
            align='center'
            className={classes.printers}
            style={{
              borderBottomColor: i === currentPrinters.length - 1 && 'transparent'
            }}
          >
            {e}
          </TableCell>
        </TableRow>
      ))
    );
  };

  renderSearchPrinters = () => {
    const { printers, selectedPrinter } = this.state;
    return (
      <List>
        {printers &&
          printers.map((e, i) => (
            <ListItem
              className='px-2'
              button
              selected={selectedPrinter === i}
              onClick={event => handleListItemClick(event, i, this)}
              key={i.toString()}
            >
              <ListItemIcon>
                <PrintTwoToneIcon />
              </ListItemIcon>
              <ListItemText primary={e} root />
            </ListItem>
          ))}
      </List>
    );
  };

  render() {
    const { classes, history, sidebarCollapse } = this.props;
    const { addPrintModal, isSearchingPrinters, isLoading, currentPrinters } = this.state;
    return (
      <div className={`col-12 p-4 ${sidebarCollapse && 'col-lg-10'} px-0`}>
        <div className='row ml-0 mr-0  align-items-center w-100 justify-content-between'>
          <BackButton
            className='pl-0'
            onClick={() => history.goBack()}
            title={settings.printers.text}
            subtitle={settings.printers.description}
          />

          <Button
            color='secondary'
            onClick={() => handleChangePrinter(this)}
            outlined
            className='col-12 col-md-4 col-xl-3'
          >
            <div className='row justify-content-center align-items-center mr-0 ml-0'>
              <AddIcon className={classes.addIcon} style={{ marginRight: '6px' }} />
              <p className='m-0'>Ajouter une imprimante</p>
            </div>
          </Button>
        </div>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  align='center'
                  className={classes.title}
                  style={{ borderBottomColor: !currentPrinters.length > 0 && 'transparent' }}
                >
                  Imprimantes
                </TableCell>
              </TableRow>
            </TableHead>
            {currentPrinters && <TableBody>{this.renderPrinters()}</TableBody>}
          </Table>
        </Paper>

        <Modal
          isOpen={addPrintModal}
          padding='none'
          color='secondary'
          title='Imprimante'
          header
          loading={isLoading}
          size='lg'
          showCancelBtn
          handleClose={() => handleClose(this)}
          onClick={() => selectPrinter(this)}
          btnTxt='Enregistrer'
        >
          <div className='py-3 px-3'>
            {isSearchingPrinters ? (
              <center>
                <Spinner className={classes.progress} />
              </center>
            ) : (
              this.renderSearchPrinters()
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, sidebar }) {
  const { shop } = firebaseRealTime;
  const { sidebarCollapse } = sidebar;
  return {
    configurations: shop,
    sidebarCollapse
  };
}

PrinterConfig.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(PrinterConfig)));
